import type { SkillId } from "@idle-rpg/shared";
import { ICONS } from "./icons";

const SKILL_LABELS: Partial<Record<SkillId, string>> = {
  character: "Character",
  mining: "Mining",
  woodcutting: "Woodcutting",
  fishing: "Fishing",
  fletching: "Fletching",
  thieving: "Thieving",
  magic: "Magic",
  brewing: "Brewing",
  herblore: "Herblore",
  refining: "Refining",
  smithing: "Smithing",
  cooking: "Cooking",
  clothing: "Clothing",
  enameling: "Enameling",
  inscribing: "Inscribing",
  enchanting: "Enchanting"
};

export type SkillSectionId = "core" | "gathering" | "processing" | "social" | "magic";

const SKILL_SECTIONS: Partial<Record<SkillId, SkillSectionId>> = {
  character: "core",
  mining: "gathering",
  woodcutting: "gathering",
  fishing: "gathering",
  herblore: "gathering",
  refining: "processing",
  smithing: "processing",
  cooking: "processing",
  brewing: "processing",
  fletching: "processing",
  clothing: "processing",
  enameling: "processing",
  inscribing: "processing",
  enchanting: "processing",
  thieving: "social",
  magic: "magic"
};

export function skillLabel(skillId: SkillId | string): string {
  return (SKILL_LABELS as Record<string, string | undefined>)[skillId] ?? capitalize(skillId);
}

export function skillIcon(skillId: SkillId | string): string {
  return (ICONS.skills as Record<string, string | undefined>)[skillId] ?? ICONS.ui.unknown;
}

export function skillSection(skillId: SkillId | string): SkillSectionId {
  return (SKILL_SECTIONS as Record<string, SkillSectionId | undefined>)[skillId] ?? "core";
}

function capitalize(value: string): string {
  return value ? value.charAt(0).toUpperCase() + value.slice(1) : value;
}
